<template>
  <div class="qq-invite-card">
    <div class="content">
        <div class="kf-detail">
            <p class="avatar">
              <img :src="message.avatar">
            </p>
            <dl class="detail">
                <dt>{{ message.name }}</dt>
                <dd v-if="message.corpName">
                  {{ message.corpName }}
                  <span class="resign" v-if="message.position">{{ message.position }}</span>
              </dd>
            </dl>
        </div>
        <a
          href="javascript:;"
          class="btn-act"
          data-style="button"
          style="background-color: #4A70FF;"
          @click="$emit('onLunchQQ', data)"
        >
          发起QQ会话
        </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    message() {
      return this.data.msgBody ?? {};
    },
  },
};
</script>

<style lang="less" scoped>
.qq-invite-card {
  padding-bottom: 8px;
  .content {
    clear: both;
    position: relative;
    width: 290px;
    min-height: 130px;
    padding: 15px;
    background-color: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    border: 1px solid #cfdbe2;
    .kf-detail {
      padding-bottom: 15px;
      min-height: 54px;
      .avatar {
        float: left;
        width: 50px;
        height: 50px;
        padding: 1px 14px 0 5px;
        font-size: 0;
        img {
          width: 50px;
          height: 50px;
          border-radius: 50px;
        }
      }
      .detail {
        position: relative;
        overflow: hidden;
        font-size: 14px;
        color: #000;
        margin: 0;
        dt {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 7px 0 8px;
          font-size: 18px;
        }
        dd {
          margin: 0;
          word-break: break-all;
          word-wrap: break-word;
          white-space: pre-wrap;
          line-height: 1.4;
        }
        .resign {
          margin-left: 10px;
        }
      }
    }
    .btn-act {
      clear: both;
      display: block;
      height: 30px;
      color: #fff;
      text-align: center;
      line-height: 30px;
      border-radius: 5px;
      background-color: #4A70FF;
      font-size: 14px;
    }
  }
}
</style>

